import { Button } from "@/components/ui/button"
import { X } from "lucide-react"
import { useNavigate } from "react-router-dom"

export default function SpecialDeckEmptyState() {
  const navigate = useNavigate()

  return (
    <div className="flex size-full flex-col justify-between bg-white bg-gradient-to-t from-white to-[#FFEDD5]">
      <div className="flex w-full shrink-0 items-center justify-end">
        <Button className="bg-transparent" onClick={() => navigate("/flashcards")}>
          <X className="text-gray-500" />
        </Button>
      </div>

      <div className="mb-5 flex size-full flex-col overflow-hidden p-4 py-0 text-center">
        <div className="w-full shrink-0 overflow-hidden">
          <p className="mb-3 mt-3 text-lg font-normal">Felicitaciones</p>
          <p className="text-2xl font-bold">¡Estás al dia!</p>
        </div>
        <img
          alt="logo"
          src="https://storage.googleapis.com/educabot-aec-cdn-1/tich/images/special-deck-empty-state.png"
          className="mx-auto block h-full max-h-[400px] max-w-full overflow-hidden object-contain"
        />
        <div className="w-full shrink-0 overflow-hidden">
          <p className="text-lg font-normal text-gray-500">A menos que... </p>
          <p className="mx-auto w-56 text-lg font-semibold text-gray-500">
            todavía no hayas cargado todos tus documentos 🤨
          </p>
        </div>
      </div>

      <div className="w-full shrink-0 overflow-hidden p-4">
        <Button
          onClick={() => navigate("/new-study-session?type=flashcards")}
          className="w-full lg:mx-auto lg:block lg:w-auto lg:text-center"
        >
          Crear más flashcards
        </Button>
      </div>
    </div>
  )
}
